import { render, staticRenderFns } from "./WorkSuccessCenters.vue?vue&type=template&id=94ece278&"
import script from "./WorkSuccessCenters.vue?vue&type=script&lang=js&"
export * from "./WorkSuccessCenters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports